import log from 'loglevel';

log.setDefaultLevel(log.levels.DEBUG);
class Log {
  debug(...args) {
    log.debug(...args);
  }

  info(...args) {
    log.info(...args);
  }

  warn(...args) {
    log.warn(...args);
  }

  error(...args) {
    log.error(...args);
  }
}

export default new Log();
